'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ScriptLoader = require('acq-components/lib/base-components/ScriptLoader/ScriptLoader');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleDisplayNetwork = function (_React$Component) {
  (0, _inherits3.default)(GoogleDisplayNetwork, _React$Component);

  function GoogleDisplayNetwork(props) {
    (0, _classCallCheck3.default)(this, GoogleDisplayNetwork);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleDisplayNetwork.__proto__ || (0, _getPrototypeOf2.default)(GoogleDisplayNetwork)).call(this, props));

    _this.state = {
      clientRendered: false
    };
    return _this;
  }

  (0, _createClass3.default)(GoogleDisplayNetwork, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var googleTag = this.props.dataConfig.googleTag;


      this.setState({
        clientRendered: true,
        googleDisplayNetworkId: googleTag.googleDisplayNetworkId,
        dbmId: googleTag.dbmId,
        gAnalyticsId: googleTag.googleAnalytics && googleTag.googleAnalytics,
        customMap: googleTag && googleTag.googleAnalyticsMap || '',
        googleTag: googleTag
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      var googleTag = this.state.googleTag;


      if (this.state.clientRendered) {
        {
          (0, _keys2.default)(googleTag).map(function (tag) {
            if (tag == 'googleAnalyticsMap') {
              return null;
            } else {
              var tagName = tag + 'Js';
              var googleDataLayer = document.getElementById(tagName) || document.createElement('script');
              var tagNameJs = 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag(\'js\', new Date()); gtag(\'config\', ' + googleTag[tag] + ' ' + (_this2.state.customMap && ',{\'custom_map\': {\'dimension1\': \'clientId\'}}') + ');';
              googleDataLayer.id = tagName;

              !googleDataLayer.textContent && googleDataLayer.appendChild(document.createTextNode(tagNameJs));
              document.body.appendChild(googleDataLayer);
            }
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          clientRendered = _state.clientRendered,
          googleTag = _state.googleTag;

      if (!clientRendered) {
        return null;
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        (0, _keys2.default)(googleTag).map(function (tag) {
          if (tag == 'googleAnalyticsMap') {
            return null;
          }
          return _react2.default.createElement(_ScriptLoader.ScriptLoader, {
            scriptId: tag,
            scriptSrc: 'https://www.googletagmanager.com/gtag/js?id=' + googleTag[tag],
            async: true,
            shouldUnmount: true
          });
        })
      );
    }
  }]);
  return GoogleDisplayNetwork;
}(_react2.default.Component);

exports.default = GoogleDisplayNetwork;